
<div class="login_flex" >
    <div class="iltt_colone">
        <div class="log_colone">
            <h1 class="log_head"></h1>
        </div>
        <div class="log_colone_topper">
            <figure class="mb-0 loginsri">
                <img src="../../assets/image/sri_logo.png" alt="loginimg" class="loginimg">
            </figure>
        </div>
        <div class="aced_comp">
            <p class="log_acedstudents">Sri Chaitanya Employee App</p>
        </div>
        <div class="log_colone_topper">
            <figure class="mb-0 ">
                <img src="../../../assets/image/Employee_img .svg" alt="loginimg" class="emploginimg">
            </figure>
        </div>
    </div>
    <div class="iltt_coltwo">
        <div class="row">
            <div class="col-md-12">
                <div class="log_card">
                    <form class="form-horizontal" [formGroup]="loginform" >
                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="mis_sign_achd"><span>
                                        <img src="../../../assets/image/favicon.ico" alt="sclogo" class="sclogo"></span>
                                    Sign in to your account
                                </h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <input type="email" class="form-control" id="inputEmail3"
                                        placeholder="Employee Id" formControlName="userName" >
                                    <i class="fa fa-user"></i>
                                    <div *ngIf="(loginform.controls['userName'].touched||isFormInvalid)&&loginform.get('userName')?.hasError('required')"
                                    style="color: rgb(255, 0, 0);">* Payroll ID must be required</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group help">
                                    <input [type]="showpassword ? 'text':'password'" class="form-control" id="inputPassword3"
                                        placeholder="Password" formControlName="password">
                                    <i class="fa fa-lock"></i>
                                    <a class="eyeslash">
                                    <i (click)="toggleshow()"  class="fa-solid fa-eye" *ngIf="showpassword"></i>
                                    <i (click)="toggleshow()"  class="fa-solid fa-eye-slash" *ngIf="!showpassword"></i></a>
                                    <div *ngIf="(loginform.controls['password'].touched||isFormInvalid)&&loginform.get('password')?.hasError('required')"
                                    style="color: rgb(255, 0, 0);">* password must be required</div>
                                    <div *ngIf="errorDescription">
                                        <small class="text-danger" style="text-align: right; width: 85%;">*{{errorDescription}}</small>
                                    </div>
                                    <div *ngIf="loginserver">
                                        <small class="text-danger" style="text-align: right; width: 85%;">*Internal Server Error</small>
                                    </div>
                                    <div *ngIf="deactivated">
                                        <small class="text-danger" style="text-align: right; width: 85%;">*Your Account is Deactivated</small> 
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" class="mis_loginbtn"  (click)="submit()" >Login</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- ================== loader ==================-->

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>







